import React, { useContext, useState, useEffect, useMemo, useRef } from "react";
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, IconButton, Collapse, Typography, FormControl, InputLabel, Select,
  Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle, Button
} from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import LoaderAnimation from "pages/LoaderAnimation";
import moment from "moment";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import AximDropdown from "components/Dropdown/AximDropdown";
import { Utils } from "common/Utils";
import TableAllData from "../CustomTable/TableAllData";
import AximTooltip from "components/AximTooltip";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import UpdateEmployeeBenefit from "area/employer/EmployeeDashboard/UpdateEmployeeBenefit";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
const formatDate = (date) => date === null ? "N/A" : moment(date).format("MM/DD/YYYY");

function Row(props) {
  const { row } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' }, ...(isOpen && { backgroundColor: (theme) => alpha(theme.palette.secondary.main, .2) }) }}>
        {/* <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell> */}
        <TableCell component="th" scope="row">
          {row.benefit}
        </TableCell>
        <TableCell>{row.status}</TableCell>
        <TableCell>{row.benefitType}</TableCell>
        <TableCell>{formatDate(row.startDate)}</TableCell>
        <TableCell>{formatDate(row.endDate)}</TableCell>
        <TableCell>{row.coverage}</TableCell>
        <TableCell>{row.carrier}</TableCell>
      </TableRow>
    </React.Fragment>
  )
}

Row.propTypes = {
  row: PropTypes.shape({
    benefit: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    benefitType: PropTypes.string.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        startDate: PropTypes.instanceOf(Date).isRequired,
        endDate: PropTypes.instanceOf(Date).isRequired,
        coverageAmount: PropTypes.number.isRequired,
        eeMonthlyCost: PropTypes.number.isRequired,
        erMonthlyCost: PropTypes.number.isRequired,
      }),
    ).isRequired,
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    coverage: PropTypes.string.isRequired,
    carrier: PropTypes.string.isRequired,
  }).isRequired,
};

function Benefits({ employeeId, insuredId, benefitPackageId, benefitDate }) {
  const editBenefitsRef = useRef({});
  const { companyId } = useContext(PrivateRoutesContext);

  const [planPeriods, setPlanPeriods] = useState([]);
  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState('');

  const [allBenefitPeriods, setAllBenefitPeriods] = useState([]);

  const [selectedBenefitPeriod, setSelectedBenefitPeriod] = useState('');
  const [benefitPeriods, setBenefitPeriods] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openEditBenefitsModal, setOpenEditBenefitsModal] = useState(false)
  const [fetchedEditBenefitsData, setFetchedEditBenefitsData] = useState(null)
  const [availableBenefits, setAvailableBenefits] = useState([])
  useEffect(() => {
    apiGet(apiUrls.getEmpBenefitsDropdowns(employeeId)).then(
      (response) => {
        setPlanPeriods(response.data);

        if (response.data.length > 0) {
          setSelectedPlanPeriod(response.data[0].planPeriodId);
        }
      }
    )
      .catch((e) => {

      });
  }, [employeeId])

  useEffect(() => {
    // TODO: Update this to use employeeId
    apiGet(apiUrls.getBenefitPayPeriods(companyId)).then(
      (response) => {
        //setBenefitPeriods(response.data);
        setAllBenefitPeriods(response.data);

      }
    )
      .catch((e) => {

      });
  }, [companyId]);

  useEffect(() => {
    var pp = planPeriods.find(p => p.planPeriodId === selectedPlanPeriod);

    if (pp) {
      var bp = allBenefitPeriods.filter(a => new Date(pp.beginDate) <= new Date(a.benefitDate) && new Date(a.benefitDate) <= new Date(pp.endDate));

      setBenefitPeriods(bp);
    }
  }, [selectedPlanPeriod, allBenefitPeriods])

  useEffect(() => {
    if (benefitPeriods.length > 0) {
      let closed = benefitPeriods.filter(x => x.statusCode === 'CLOSE');
      if (closed.length === 0) {
        let currentTime = new Date();
        let latest = benefitPeriods.filter(x => Date.parse(x.benefitDate) < currentTime);

        if (latest.length === 0) {
          setSelectedBenefitPeriod(benefitPeriods[0].payPeriodID);
        }
        else {
          setSelectedBenefitPeriod(latest[0].payPeriodID);
        }
      }
      else {
        setSelectedBenefitPeriod(closed[0].payPeriodID);
      }
    }
  }, [benefitPeriods])

  useEffect(() => {
    if (selectedBenefitPeriod) {
      setIsLoading(true);

      apiGet(apiUrls.getEmpEnrollments(employeeId, selectedBenefitPeriod)).then(
        (response) => {
          console.log(response.data, 'erollment data ');
          setEnrollments(response.data);
          setIsLoading(false);
        }
      )
        .catch((e) => {

        });
    }
  }, [employeeId, selectedBenefitPeriod]);

  const openEditBenefit = (row) => {
    console.log(row.original, 'data')
    setOpenEditBenefitsModal(true)
    setFetchedEditBenefitsData(row.original)
    setAvailableBenefits([])
  }

  const openAddBenefit = () => {
    setOpenEditBenefitsModal(true)
    let bp = benefitPeriods.find(b => b.payPeriodID == selectedBenefitPeriod);
    let benefitDate = Utils.convertToDatePicker(bp.benefitDate);
    console.log(bp, 'bp')
    console.log(benefitDate, 'benefitDate')
    apiGet(apiUrls.getAvailableEnrollments(companyId, insuredId, benefitPackageId, benefitDate)).then(
      (response) => {
        console.log(response.data, 'data');
        setAvailableBenefits(response.data)
      }
    )
      .catch((e) => {
        console.log(e, 'error')
      });
    let newEnrollment =
    {
      enrollmentID: Utils.emptyGuid(),
      insuredID: insuredId,
      benefitCoverageID: null,
      benefit: null,
      status: "Active",
      benefitType: null,
      coverage: null,
      carrier: null,
      benefitID: null,
      coverageLevelID: null,
      benefitTypeID: null,
      planPeriodID: null,
      startDate: null,
      endDate: '9999-01-01',
      coverageAmount: null,
      eeMonthlyCost: null,
      erMonthlyCost: null
    }
    setFetchedEditBenefitsData(newEnrollment)
  }

  const columns = useMemo(() => [
    {
      Header: "Edit",
      accessor: "enrollmentID",
      Cell: ({ row }) => (
        <AximTooltip title="Update">
          <IconButton color="primary" onClick={() => { openEditBenefit(row) }}>
            <EditOutlinedIcon />
          </IconButton>
        </AximTooltip>
      ),
    },
    {
      Header: "BenefitType",
      accessor: "benefitType",
    },
    {
      Header: "Benefit",
      accessor: "benefit",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Start Date",
      accessor: (cell) => Utils.formatDate(cell.startDate),
      Cell: ({ row }) => (
        <Box>
          {Utils.formatDate(row.original.startDate)}
        </Box>
      ),
      sortType: "dateSort",
    },
    {
      Header: "End Date",
      accessor: (cell) => Utils.formatDate(cell.endDate),
      Cell: ({ row }) => (
        <Box>
          {Utils.formatDate(row.original.endDate)}
        </Box>
      ),
      sortType: "dateSort",
    },
    {
      Header: "Coverage",
      accessor: "coverage",
    },
    {
      Header: "Carrier",
      accessor: "carrier",
    },
  ]);

  const handleEditBenefitSave = () => {
    console.log(editBenefitsRef)
    if (editBenefitsRef != null && editBenefitsRef.current.formData !== undefined) {
      let data = editBenefitsRef.current.formData;
      let postData = {
        EnrollmentID: data.enrollmentID,
        InsuredID: data.insuredID,
        BenefitID: data.benefitID,
        CoverageLevelID: data.coverageLevelID,
        StartDate: data.startDate,
        EndDate: (data.termDate ? data.termDate : data.endDate),
        CoverageAmount: data.coverageAmount,
        EEMonthlyCost: (data.eeMonthlyCost == "" ? null : data.eeMonthlyCost),
        ERMonthlyCost: (data.erMonthlyCost == "" ? null : data.erMonthlyCost),
      };
      console.log(postData, 'postData')
      apiPost(apiUrls.postEnrollment(employeeId), postData)
        .then((response) => {
          console.log(response, 'update enrollment response')
          setOpenEditBenefitsModal(false)

          apiGet(apiUrls.getEmpBenefitsDropdowns(employeeId)).then(
            (response) => {
              setPlanPeriods(response.data);

              if (response.data.length > 0) {
                setSelectedPlanPeriod(response.data[0].planPeriodId);
              }
            }
          )
            .catch((e) => {

            });
        })
        .catch((e) => {
          console.log(e, "CATCHED");
        })
        .finally(() => {
          //setSaving(false);
        });;

    }
    else {
      console.log('no change')
    }
  }

  return (
    <>
      <Box className="container-fluid">
        <Box sx={{ display: "flex" }}>
          <AximDropdown
            label="Plan Period"
            value={selectedPlanPeriod}
            handleChange={(e) => setSelectedPlanPeriod(e.target.value)}
            pairs={planPeriods.map(p => { return { value: p.planPeriodId, text: p.label } })}
          />

          <AximDropdown
            label="Benefit Date"
            value={selectedBenefitPeriod}
            handleChange={(e) => setSelectedBenefitPeriod(e.target.value)}
            pairs={benefitPeriods.map(x => ({ value: x.payPeriodID, text: Utils.formatDate(x.benefitDate) }))}
          />
          {selectedBenefitPeriod ? <Button onClick={openAddBenefit}>Add Benefit</Button> : <></>}
        </Box>
        <Box>
          <TableAllData columns={columns} data={enrollments} isLoading={isLoading}
          />
        </Box>
      </Box>

      {/* Update Benefits Modal */}
      <Dialog
        open={openEditBenefitsModal}
        onClose={() => { setOpenEditBenefitsModal(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Update Employee Benefits
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>

          {fetchedEditBenefitsData !== undefined ? (
            <form noValidate autoComplete="off" className="grid">
              <UpdateEmployeeBenefit fetchedData={fetchedEditBenefitsData} ref={editBenefitsRef} benefitPackageId={benefitPackageId} employeeId={employeeId} benefits={availableBenefits}></UpdateEmployeeBenefit>
            </form>
          ) : (
            <h3>No Data Available</h3>
          )}
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleEditBenefitSave}
            className={ButtonStyle.CcancelBtn}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => { setOpenEditBenefitsModal(false) }}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}

export default Benefits;
